import { useEffect, useRef } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Slider from "react-slick";
import CheckIcon from "@mui/icons-material/Check";
import BeautyHeader from "./BeutyHeader";
import "./style/Beauty.style.scss";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import Feedback from "../../Components/Common/Feedback";
import FlipImage from "../../Components/Common/FlipImage";
import BusinessHero from "../../Components/Common/BusinessHero";
import Hardware from "../../Components/Common/Hardware";
import Meta from "../../Components/Meta";

export default function Barbershop() {
  const containerRef = useRef(null);
  const router = useNavigate();

  const settings1 = {
    infinite: true,
    speed: 500,
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const { setCtaSec } = useOutletContext();

  useEffect(() => {
    setCtaSec({
      title: "Smarter POS. Custom Fit.",
      desc: "Tell us about your business and get a POS setup made for you.",
      btn: " Get Started Now",
      img: "/assets/img/footer/c20.webp",
    });
  }, [setCtaSec]);

  const slider1 = useRef(null);

  const flipImgs = {
    imgf1: "/assets/img/barber/a1.webp",
    imgf2: "/assets/img/barber/a2.webp",
    imgf3: "/assets/img/barber/a3.webp",
    imgf4: "/assets/img/barber/a4.webp",
    imgf5: "/assets/img/barber/a5.webp",
    imgb1: "/assets/img/barber/b1.webp",
    imgb2: "/assets/img/barber/b2.webp",
    imgb3: "/assets/img/barber/b3.webp",
    imgb4: "/assets/img/barber/b4.webp",
    imgb5: "/assets/img/barber/b5.webp",
  };

  const heroObj = {
    // video: "/assets/img/barber/barbershop.webm",
    // videoM: "/assets/img/barber/barbershopM.webm",
    video: "https://fusionbucket.co.uk/FMB/Business-type/Barber/barbershop.webm",
    videoM: "https://fusionbucket.co.uk/FMB/Business-type/Barber/barbershopM.webm",
    title: "Fusion for Barber Shops",
    subTitle: "Turn Chairs Faster. Run Smarter.",
    desc: "All-in-one POS to manage bookings, sales, and stock with ease.",
    btn1: "Start Free Trial",
    btn2: "Explore Features",
  };

  return (
    <>
      <Meta
        title={"Fusion Barbershop POS | All-in-One POS System for Barbers"}
        desc={
          "Keep your chairs turning and your business flowing with Fusion — the all-in-one POS solution that simplifies sales, scheduling, and inventory for barbershops."
        }
        url={window.location.href}
        keywords={
          "barbershop POS, barber shop software, POS for barbers, Fusion barbershop POS, barber scheduling software, barbershop inventory management, all-in-one POS system, barbershop business tools, barber appointment software, manage barber shop sales"
        }
      />

      <BeautyHeader />

      <BusinessHero heroObj={heroObj} />

      <FlipImage imgObj={flipImgs} />

      <div ref={containerRef} className=" overflow-hidden mb-3">
        <div className="pos_tile mt-5">
          <h1 className="mb-2">Everything You Need. All in One Place.</h1>
        </div>
        <div data-aos="zoom-in-up" className="panel panel1 mb-3">
          <div className="salon_sec  h-100">
            <div className="container">
              <div className="first_o mb-3">
                <div className="sod_oi">
                  <div className="ktp_oi">
                    <div className="left_io">
                      <div className="left_p1 hold">
                        <img
                          loading="lazy"
                          src="/assets/img/barber/standout.webp"
                          alt="Stand out with Fusion POS designed for modern barbershops"
                          className="res_img rounded-4"
                        />
                      </div>
                    </div>
                    <div className="right_io">
                      <div className=" right_p1 hold d-flex gap-3 flex-column text-start">
                        <div className=" pos_tile text-start ">
                          <h2 className="mb-2">
                            No-show & cancellation protection
                          </h2>
                          <h6 className="text-dark">
                            Assign chairs, barbers, and time slots with
                            drag-and-drop ease
                          </h6>
                        </div>
                        <hr />
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/pencil.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            {" "}
                            Color-coded calendars.
                          </h5>
                        </div>
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/Action_Select_all.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            Auto-confirmations & AI rescheduling
                          </h5>
                        </div>
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/Business_types.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            {" "}
                            No-show & cancellation protection
                          </h5>
                        </div>
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/Benefits_Image_3.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            {" "}
                            Fill gaps with smart waitlists
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-aos="zoom-in-up" className="panel panel2 mb-3">
          <div className="salon_sec  h-100">
            <div className="container">
              <div className="first_o mb-3">
                <div className="sod_oi">
                  <div className="ktp_oi">
                    <div className="left_io">
                      <div className="left_p1 hold">
                        <img
                          loading="lazy"
                          src="/assets/img/barber/take-pay.webp"
                          alt="Barber software with integrated card and contactless payment options"
                          className="res_img rounded-4"
                        />
                      </div>
                    </div>
                    <div className="right_io">
                      <div className=" right_p1 hold d-flex gap-3 flex-column text-start">
                        <div className=" pos_tile text-start ">
                          <h2 className="mb-2">
                            Barber POS with Built-In Payments – No Hardware
                            Needed
                          </h2>
                          <h6 className="text-dark">
                            Take payments at the chair, front desk, or on the
                            go.
                          </h6>
                        </div>
                        <hr />
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/pencil.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            {" "}
                            Tap to Pay on iPhone & Android
                          </h5>
                        </div>
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/Action_Select_all.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            Accept all major cards & wallets
                          </h5>
                        </div>
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/Business_types.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            {" "}
                            Cash App, Afterpay, Apple Pay, Google Pay
                          </h5>
                        </div>
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/Benefits_Image_3.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            {" "}
                            Instant payouts with Fusion Checking¹
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-aos="zoom-in-up" className="panel panel3 mb-3">
          <div className="salon_sec  h-100">
            <div className="container">
              <div className="first_o mb-3">
                <div className="sod_oi">
                  <div className="ktp_oi">
                    <div className="left_io">
                      <div className="left_p1 hold">
                        <img
                          loading="lazy"
                          src="/assets/img/barber/keep-our.webp"
                          alt="Reliable barber POS system to keep operations on track"
                          className="res_img rounded-4"
                        />
                      </div>
                    </div>
                    <div className="right_io">
                      <div className=" right_p1 hold d-flex gap-3 flex-column text-start">
                        <div className=" pos_tile text-start ">
                          <h2 className="mb-2">Keep Your Chair Booked Solid</h2>
                          <h6 className="text-dark">
                            Let clients book 24/7 through your online booking
                            site.
                          </h6>
                        </div>
                        <hr />
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/pencil.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            {" "}
                            Add “Book Now” to Instagram & Facebook
                          </h5>
                        </div>
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/Action_Select_all.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            Get listed on Fusion Go – our free barber
                            marketplace.{" "}
                          </h5>
                        </div>
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/Business_types.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            {" "}
                            Track data to offer more of what clients love
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-aos="zoom-in-up" className="panel panel4 mb-3">
          <div className="salon_sec  h-100">
            <div className="container">
              <div className="first_o mb-3">
                <div className="sod_oi">
                  <div className="ktp_oi">
                    <div className="left_io">
                      <div className="left_p1 hold">
                        <img
                          loading="lazy"
                          src="/assets/img/barber/create-exp.webp"
                          alt="Barbershop software to deliver personalized grooming experiences"
                          className="res_img rounded-4"
                        />
                      </div>
                    </div>
                    <div className="right_io">
                      <div className=" right_p1 hold d-flex gap-3 flex-column text-start">
                        <div className=" pos_tile text-start ">
                          <h2 className="mb-2">
                            Barber Shop Software That Builds Loyalty
                          </h2>
                          <h6 className="text-dark">
                            Create personalized grooming experiences and bring
                            clients back.
                          </h6>
                        </div>
                        <hr />
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/pencil.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            {" "}
                            Save notes, preferences, and history
                          </h5>
                        </div>
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/Action_Select_all.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            Send SMS & email offers with Fusion Marketing
                          </h5>
                        </div>
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/Business_types.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            {" "}
                            Boost retention with Fusion Loyalty
                          </h5>
                        </div>
                        <div className="d-flex gap-2 align-items-start mb-2">
                          <img
                            loading="lazy"
                            src="/assets/img/Benefits_Image_3.svg"
                            className="star2 bg-white"
                            alt=""
                          />
                          <h5 className="mb-0 text-black">
                            {" "}
                            Chat in real time with Fusion Messages inbox
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Feedback />

      <section data-aos="fade-up" className="salon_sec text-start">
        <div className="container">
          <div className="pos_tile">
            <h1 className="mb-3">Tools to Power What’s Next</h1>
            <p>
              Grow faster with Fusion’s built-in banking, retail, and marketing
              solutions — all designed for beauty and grooming businesses.
            </p>
          </div>
          <div className="row h-100 mb-4">
            <div className="col-lg-4 col-sm-6 mb-3">
              <video
                autoPlay
                playsInline
                muted
                loop
                width="100%"
                className="rounded-4 mb-4"
              >
                <source
                  src={"https://fusionbucket.co.uk/FMB/Business-type/beauty/beauty.webm"}
                  // src={"/assets/img/beauty/beauty.webm"}
                  type="video/webm"
                ></source>
              </video>

              <div className="pos_tile">
                <h2 className="mb-3 fw-bolder">
                  Stay in Control of Your Cash Flow
                </h2>
                <p>
                  Sync payments, track income, and access funds fast — all from
                  one dashboard. Easily qualify for funding to grow your
                  business.
                </p>
                <Link to="/get-started" className="text-color">
                  Explore Fusion Banking{" "}
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-3">
              <video
                autoPlay
                playsInline
                muted
                loop
                width="100%"
                className="rounded-4 mb-4"
              >
                <source
                  src={"https://fusionbucket.co.uk/FMB/Business-type/beauty/beauty2.webm"}
                  // src={"/assets/img/beauty/beauty2.webm"}
                  type="video/webm"
                ></source>
              </video>

              <div className="pos_tile">
                <h2 className="mb-3 fw-bolder">Add New Revenue Streams</h2>
                <p>
                  Sell retail products online and in-store with full inventory
                  sync. Launch a branded eCommerce site and offer prepaid
                  service packages.
                </p>
                <Link to="/get-started" className="text-color">
                  Explore Fusion Online{" "}
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-3">
              <video
                autoPlay
                playsInline
                muted
                loop
                width="100%"
                className="rounded-4 mb-4"
              >
                <source
                  src={"https://fusionbucket.co.uk/FMB/Business-type/beauty/message.webm"}
                  // src={"/assets/img/beauty/message.webm"}
                  type="video/webm"
                ></source>
              </video>

              <div className="pos_tile">
                <h2 className="mb-3 fw-bolder">Bring In More Business</h2>
                <p>
                  Send powerful email and SMS campaigns in minutes. Reach more
                  clients, fill your calendar, and boost repeat visits.
                </p>
                <Link to="/get-started" className="text-color">
                  Explore Fusion Marketing{" "}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Hardware />

      <section data-aos="fade-up" className="payment-sec conversion-s">
        <div className="container">
          <div className="row h-100 mb-3">
            <div className="pos_tile text-start col-lg-7">
              <h1 className="mb-0">Bundles for every barbershop</h1>
            </div>
            <div className="col-lg-5 mb-3">
              <div className=" d-flex h-100 align-items-end justify-content-end">
                <button type="button" className="btn btn-lm">
                  Learn more
                </button>
              </div>
            </div>
          </div>

          <div className="row h-100 mt-4">
            <div className="col-lg-4">
              <div className=" rate-pay bg-white text-start h-100 ">
                <div className="pos_tile gap-3 mb-3 flex-column  d-flex border-bottom">
                  <h2 className="mb-3">Starter</h2>
                  <p>
                    The basics to run your business while staying ahead of
                    schedule
                  </p>
                </div>
                <div className="pos_tile gap-3 flex-column  d-flex ">
                  <div className="v">
                    <h1 className="mb-2">£18/week.</h1>
                    <p>
                      for a single location{" "}
                      <span className="fw-bolder">+ processing fees</span>
                    </p>
                  </div>
                </div>

                <div className="text-start mt-4">
                  <h3 className="text-dark fw-bolder">Top features:</h3>
                  <p className="d-flex gap-1">
                    <CheckIcon /> <span>Unlimited staff accounts</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon />{" "}
                    <span>
                      Custom booking website and social media integrations
                    </span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon /> <span>Integrated payments</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon />{" "}
                    <span>Automatic text and email reminders</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon /> <span>Automated contracts</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon />{" "}
                    <span>
                      Marketplace app for beauty and personal care discovery
                    </span>
                  </p>
                </div>

                <button
                  type="button"
                  onClick={() => router("/pricing")}
                  className="btn btn-lm"
                >
                  sign up for free
                </button>
              </div>
            </div>
            <div className="col-lg-4">
              <div className=" rate-pay bg-white text-start h-100 ">
                <div className="pos_tile gap-3 mb-3 flex-column  d-flex border-bottom">
                  <h2 className="mb-3">Plus</h2>
                  <p>
                    More advanced features for growing teams that offer
                    top-notch service
                  </p>
                </div>

                <div className="pos_tile gap-3 flex-column  d-flex ">
                  <div className="v">
                    <h1 className="mb-2">£26/week.</h1>
                    <p>
                      per location{" "}
                      <span className="fw-bolder">+ processing fees</span>
                    </p>
                  </div>
                </div>

                <div className="text-start mt-4">
                  <h3 className="text-dark fw-bolder">Top features:</h3>
                  <p className="d-flex gap-1">
                    <CheckIcon />{" "}
                    <span>Everything in Fusion Appointments Free</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon />{" "}
                    <span>Customer confirmation texts and emails</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon /> <span>Cancellation policy and fees</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon /> <span>Class scheduling</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon /> <span>Waitlist</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon /> <span>Appointments reports</span>
                  </p>
                </div>

                <button
                  type="button"
                  onClick={() => router("/pricing")}
                  className="btn btn-lm"
                >
                  Start free trail
                </button>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="rate-pay bg-white text-start h-100 ">
                <div className="pos_tile gap-3 mb-3 flex-column  d-flex border-bottom">
                  <h2 className="mb-3">Pro</h2>
                  <p>
                    A complete plan that meets complex booking and staff
                    management needs
                  </p>
                </div>
                <div className="pos_tile gap-3 flex-column  d-flex ">
                  <div className="v">
                    <h1 className="mb-2">£38/week.</h1>
                    <p>
                      per location <span className="fw-bolder"></span>
                    </p>
                  </div>
                </div>

                <div className="text-start mt-4">
                  <h3 className="text-dark fw-bolder">Top features:</h3>
                  <p className="d-flex gap-1">
                    <CheckIcon />{" "}
                    <span>Everything in Fusion Appointments Plus</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon /> <span>Advanced Access</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon />{" "}
                    <span>Select scheduling features from Fusion staff</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon /> <span>Resource management</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon /> <span>Custom staff commissions</span>
                  </p>
                  <p className="d-flex gap-1">
                    <CheckIcon /> <span>Custom contract fields</span>
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => router("/pricing")}
                  className="btn btn-lm"
                >
                  Start free trail
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section data-aos="fade-up" className="salon_sec">
        <div className="container">
          <div className="mb-5 text-start gap-3 d-md-flex  gap-2 justify-content-between align-items-center">
            <div className="pos_tile">
              <h1 className="mb-2">
                Read real stories, take away tips, and get inspired
              </h1>
            </div>

            <div className="d-flex mb-2 gap-2 align-items-center ">
              <div className="left-slide ">
                <div
                  role="button"
                  onClick={() => slider1?.current?.slickPrev()}
                  className="arr-85 p-4 rounded-circle"
                >
                  <ArrowBackIcon />
                </div>
              </div>
              <div className="right-slide ">
                <div
                  role="button"
                  onClick={() => slider1?.current?.slickNext()}
                  className="arr-85 p-4 rounded-circle"
                >
                  <ArrowForwardIcon />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center ">
          <div className="w-100">
            <Slider ref={slider1} dots {...settings1} className="">
              <div className="d-flex gap-3 flex-column text-start p-2">
                <div className="l">
                  <img
                    loading="lazy"
                    alt=""
                    className="w-100 rounded-2"
                    src="/assets/img/barber/opening.webp"
                  />
                </div>
                {/* <h3 className="">
                  {" "}
                  Opening a Barbershop: The Complete Step-by-Step Guide
                </h3> */}
              </div>
              <div className="d-flex gap-3 flex-column text-start p-2">
                <div className="l">
                  <img
                    loading="lazy"
                    alt=""
                    className="w-100 rounded-2"
                    src="/assets/img/barber/booth.webp"
                  />
                </div>
                {/* <h3 className="">
                  Booth Renters: Why You Should Consider Renting a Salon Booth
                </h3> */}
              </div>
              <div className="d-flex gap-3 flex-column text-start p-2">
                <div className="l">
                  <img
                    loading="lazy"
                    alt=""
                    className="w-100 rounded-2"
                    src="/assets/img/barber/art.webp"
                  />
                </div>
                {/* <h3 className="">
                  The Art of Balancing Regular and Walk-In Appointments
                </h3> */}
              </div>
              <div className="d-flex gap-3 flex-column text-start p-2">
                <div className="l">
                  <img
                    loading="lazy"
                    alt=""
                    className="w-100 rounded-2"
                    src="/assets/img/barber/how-make.webp"
                  />
                </div>
                {/* <h3 className="">How to Make a Booking Website</h3> */}
              </div>
              <div className="d-flex gap-3 flex-column text-start p-2">
                <div className="l">
                  <img
                    loading="lazy"
                    alt=""
                    className="w-100 rounded-2"
                    src="/assets/img/barber/area.webp"
                  />
                </div>
                {/* <h3 className="">
                  5 Areas to Leverage Automation in the Beauty Industry{" "}
                </h3> */}
              </div>
              <div className="d-flex gap-3 flex-column text-start p-2">
                <div className="l">
                  <img
                    loading="lazy"
                    alt=""
                    className="w-100 rounded-2"
                    src="/assets/img/barber/way.webp"
                  />
                </div>
                {/* <h3 className="">
                  3 Ways To Build a More Resilient Beauty Business
                </h3> */}
              </div>
            </Slider>
          </div>
        </div>
      </section>

      <section data-aos="fade-up" className="salon_sec d-none">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <div className="pos_tile text-start">
              <h1 className="mb-0">See what’s possible with Fusion</h1>
            </div>
            <div className="d-flex gap-3 align-items-center">
              <button
                onClick={() => router("/get-started")}
                className="btn btn-lm"
                type="button"
              >
                Get Started
              </button>
              <button
                className="btn btn-watch"
                onClick={() => router("/contact")}
                type="button"
              >
                Contact Sales
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
